import ReactGA from 'react-ga4';

export const trackExternalLinkClick = (url, courseTitle, partner) => {
  try {
    const domain = new URL(url).hostname;

    const isCoursera = 
      (partner?.toLowerCase() === 'coursera') || 
      (url?.toLowerCase().includes('coursera.org'));
    const eventName = isCoursera ? 'coursera_click' : 'click';
    ReactGA.event(eventName, {
      link_url: url,
      link_domain: domain,
      link_text: courseTitle,
      course_title: courseTitle,
      partner: partner,
      outbound: true
    });

    window.open(url, '_blank', 'noopener,noreferrer');
  } catch (error) {
    console.error('Error tracking external link:', error);
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};
